export {
    connectWithTranslations,
    TranslationsContainer,
    useTranslations,
} from "./translations.container";
export type { ITranslationsContainerProps } from "./translations.container";

export type { ITranslationsContainerState } from './translations';
